<template>
  <ValidationProvider v-slot="{ errors }" :name="label" :rules="rules">
    <b-field :type="{ 'is-danger': errors.length > 0 }" :message="errors[0]">
      <template slot="label">
        {{ label }}
        <!-- <sup v-if="rules && rules.includes('required')" class="has-text-danger"
          >(required)</sup
        > -->
        <b-tooltip v-if="tooltip" type="is-dark" :label="tooltip" multilined>
          <b-icon size="is-small" icon="help-circle-outline"></b-icon>
        </b-tooltip>
      </template>
      <b-timepicker
        v-model="item"
        placeholder="Click to select..."
        v-bind="$attrs"
        v-on="$listeners"
        @input="handleInput"
      >
        <b-button
          label="Now"
          type="is-primary"
          icon-left="clock"
          @click="setNow"
        />
        <b-button
          label="Clear"
          type="is-danger"
          icon-left="close"
          outlined
          @click="clearTime"
        />
      </b-timepicker>
    </b-field>
  </ValidationProvider>
</template>

<script>
import { format } from 'date-fns'

export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null
    },
    tooltip: {
      type: String,
      default: null
    },
    rules: {
      type: String,
      default: null
    },
    value: {
      type: [Date, String]
    }
  },
  data() {
    return {
      item: this.setDate(this.value)
    }
  },
  watch: {
    value(value) {
      this.item = this.setDate(value)
    }
  },
  methods: {
    formatDate(date) {
      return format(date, 'dd/MM/yyyy HH:mm')
    },
    setDate(value) {
      if (!value) return null

      if (typeof value === 'string') {
        // Check if it's a TIME-only string (HH:MM or HH:MM:SS)
        if (/^\d{2}:\d{2}(:\d{2})?$/.test(value)) {
          // TIME-only string - parse as local time with today's date
          const [hours, minutes, seconds] = value.split(':')
          const date = new Date()
          date.setHours(parseInt(hours, 10))
          date.setMinutes(parseInt(minutes, 10))
          date.setSeconds(seconds ? parseInt(seconds, 10) : 0)
          date.setMilliseconds(0)
          return date
        }
        // Full datetime string - parse normally
        return new Date(value)
      }

      return value
    },
    handleInput(value) {
      this.$emit('input', value)
    },
    setNow() {
      this.item = new Date()
      this.$emit('input', this.item)
    },
    clearTime() {
      this.item = null
      this.$emit('input', null)
    }
  }
}
</script>
